export enum Routes {
  Default = "/",
  Auth = "/auth",
  GetStarted = "/get-started",
  EntryName = "/your-name",
  EntryPreferredName = "/preferred-name",
  EntryGreeting = "/greeting",
  // Same screen as PhoneLoginInput, reached from the get-started journey rather
  // than the login options. Split so the two read apart in analytics: this is
  // signup ("EntryPhone"), that one is someone logging in.
  EntryPhone = "/entry-phone",
  SecureAccountIntro = "/secure-account-intro",
  EntryEmail = "/your-email",
  // The "Welcome back" screen offering phone/Google/email — this is the login
  // page, so the key (which doubles as the analytics screen name) says Login.
  Login = "/login-options",
  // The email + password form reached from the email option above.
  EmailLogin = "/login",
  SignUp = "/signup",
  DateOfBirth = "/date-of-birth",
  PhoneNumber = "/phone-number",
  PhoneVerification = "/phone-verification",
  Name = "/name",
  ResidentialAddress = "/residential-address",
  ResidentialAddressConfirmation = "/residential-address-confirmation",
  Citizenship = "/citizenship",
  Ssn = "/ssn",
  InvestmentPriority = "/investment-priority",
  InvestmentDownturnReaction = "/investment-downturn-reaction",
  Employment = "/employment",
  EmployerAddressAutofill = "/employer-address-autofill",
  EmployerAddress = "/employer-address",
  EmployerAddressConfirmation = "/employer-address-confirmation",
  AddBeneficiaryType = "/add-beneficiary-type",
  GoalType = "/goal-type",
  TaxFlexibility = "/tax-flexibility",
  GoalName = "/goal-name",
  TrumpAccountCheck = "/trump-account-check",
  TrumpAccountSetup = "/trump-account-setup",
  TrumpSidecarIntroduction = "/trump-sidecar-introduction",
  TrumpSidecarCurrentContribution = "/trump-sidecar-current-contribution",
  TrumpSidecarTaxCalculation = "/trump-sidecar-tax-calculation",
  TrumpSidecarRecommendedContribution = "/trump-sidecar-recommended-contribution",
  AccountType = "/account-type",
  AccountHorizon = "/account-horizon",
  GoalDeposit = "/goal-deposit",
  AddChild = "/add-child",
  ChildDeposit = "/child-deposit",
  BankLinking = "/bank-linking",
  MaritalStatus = "/marital-status",
  OnboardingComplete = "/onboarding-complete",
  Onboarding = "/onboarding",
  Dashboard = "/dashboard",
  Partnership = "/partnership",
  // The key doubles as the analytics screen name (see getRouteForPath), so this
  // reads as the prefill review it is rather than "Verified", the vendor's name.
  // The path stays "/verified" — it's a persisted step key, not a visible URL.
  // Mobile calls this same screen ReviewProfileScreen, which is taken here by a
  // different screen (the manual-entry review at Routes.ReviewProfile).
  Prefill = "/verified",
  Accounts = "/accounts",
  Transfers = "/transfers",
  Profile = "/profile",
  PhoneLogin = "/phone-login",
  OAuthCallback = "/oauth-callback",
  PhoneLoginInput = "/phone-login-input",
  PhoneLoginVerification = "/phone-login-verification",
  EmailCodeVerification = "/email-code-verification",
  PartnerExistingAccount = "/partner-existing-account",
  PersonalInformation = "/personal-information",
  EmploymentInformation = "/employment-information",
  LinkedAccounts = "/linked-accounts",
  OneTimeContribution = "/one-time-contribution",
  ContributionIndividual = "/contribution-individual",
  ContributionGoal = "/contribution-goal",
  ContributionBankAccount = "/contribution-bank-account",
  GoalsOverview = "/goals-overview",
  GoalBreakdown = "/goal-breakdown",
  EditGoal = "/edit-goal",
  ShareGoal = "/share-goal",
  ShareGoalContact = "/share-goal-contact",
  ReviewProfile = "/review-profile",
  DownloadApp = "/download-app",
  Email = "/email",
  Withdraw = "/withdraw",
  RedeemCode = "/redeem-code",
  ReferralDashboard = "/referral-dashboard",
  RequestGift = "/request-gift",
  Subscription = "/plans",
  AllocateFunds = "/allocate-funds",
  ForgotPassword = "/forgot-password",
  ForgotPasswordConfirmation = "/forgot-password-confirmation",
  ResetPassword = "/reset-password",
  ResetPasswordSuccess = "/reset-password-success",
  InsufficientBankBalance = "/insufficient-bank-balance",
  UnsupportedBank = "/unsupported-bank",
  BeneficiarySsn = "/beneficiary-ssn",
  AccountFundingSource = "/account-funding-source",
  AssetsRange = "/assets-range",
  TaxGainHarvest = "/tax-gain-harvest",
  TrustedContact = "/trusted-contact",
  Documents = "/documents",
  DocumentCategory = "/documents/category",
  AlpacaAccountDocuments = "/documents/alpaca",
  Fallback = "*",
}
